import { combineReducers } from "redux";
import mainNavbar from './cms.reducer';

const reducer = combineReducers({    
    mainNavbar
});

export default reducer;